import { render, staticRenderFns } from "./SessionDetailPlayers.vue?vue&type=template&id=bcb36b94&"
import script from "./SessionDetailPlayers.vue?vue&type=script&lang=js&"
export * from "./SessionDetailPlayers.vue?vue&type=script&lang=js&"
import style0 from "./SessionDetailPlayers.vue?vue&type=style&index=0&scooped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports